import Icon from '@material-ui/icons/Label';

export const CouponIcon = Icon;